<div
    class="fixed inset-0 bg-white bg-opacity-50 flex items-center justify-center z-50 pointer-events-auto"
>
    <mat-spinner></mat-spinner>
</div>
